<template>
  <div>
    <div v-if="isSuccess">
      <div>
        <h3 style="text-align:center;">绑定店员微信成功</h3>
      </div>
      <div>
        <van-steps
          direction="vertical"
          :active="2"
          active-color="#fea812"
          style="margin-top: 5px; padding-bottom: 10px;"
        >
          <van-step
            v-for="(step, index) in steps"
            :key="index"
          >
            <div style="line-height: 20px;">{{step.text}}</div>
            <div style="line-height: 20px;">{{step.desc}}</div>
          </van-step>
        </van-steps>
      </div>
      <div style="margin:20px;">
        <van-button
          type="primary"
          size="large"
          @click="login"
        >登录后台体验</van-button>
      </div>
    </div>
    <div v-if="!isSuccess">
      <h3 style="text-align:center;">绑定店员失败</h3>
      <h4 style="padding: 8px;">请联系技术支持人员：{{status}}</h4>
    </div>
  </div>
</template>

<script>
import { Field, Cell, CellGroup, Row, Col, Button, Steps, Step } from 'vant'

export default {
  name: 'login',
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  data() {
    return {
      isSuccess: true,
      status: 0,
      steps: [
        {
          text: '关注公众号：ieMall商城',
          desc: '可以方便收到，订单通知，平台通知等信息'
        },
        {
          text: '绑定店员微信',
          desc: '登录PC后台，点击右侧头像，获取二维码，微信扫描'
        },
        {
          text: '绑定成功',
          desc: '显示当前界面，可以通过按钮体验移动端后台'
        },
        {
          text: '登录移动端后台管理',
          desc: '查看订单，管理会员，收看通知'
        }
      ]
    }
  },
  methods: {
    login() {
      this.$router.push({ path: '/login' })
    }
  },
  created: function() {
    if (window.location.search) {
      this.isSuccess = false
      this.status = window.location.search
    }
  }
}
</script>

<style scoped>
</style>
<style type="text/css">
.van-field__control {
  line-height: 24px !important;
}
</style>
